import { compact } from 'lodash/fp'
import { createSectionCreator, createField } from '../utils'

const getQuestions = (app, id) => {
  return compact([
    createField(`${id}.useDrug.checked`, [
      {
        id: `${id}.useDrug.checked`,
        c: 'RadioButton',
        required: true,
        label:
          'ค. ท่านเคยเสพยาเสพติด หรือยาประเภทมึนเมาหรือเสพสุราเกินขนาด หรือเคยได้รับการรักษาเกี่ยวกับโรคพิษสุราเรื้อรังหรือยาเสพติดบ้างหรือไม่',
        p: {
          options: [
            {
              text: 'ไม่เคย',
              value: 'no',
            },
            {
              text: 'เคย',
              value: 'yes',
            },
          ],
        },
      },
    ]),
  ])
}

export default createSectionCreator(getQuestions)
